<div class="csv-report-wrapper">
    <app-report-select header = {{HeaderShow}}
      [reports]="true"
      [consumer]="false"
      [showSites]="false"
      [showDaterange]="reportType === 'DAILY_REPORT_CSV'||reportType ==='RECHARGE_HISTORY_CSV'"
      [SingleLocationDropdown]="true"
      [Nolocation]="true"
      [showBillNo]="false"
      [Month_Range]="reportType === 'MONTHLY_REPORT_CSV'"
      (filtersApplied)="filterApplied($event)"
      ></app-report-select>
    
      <div class="header-select-panel">
        <span class="panel-title">Select Columns</span>
        <div class="header-checkbox-list">
          @for (header of headers; track header.key) {
            <label class="header-checkbox">
              <input
                type="checkbox"
                [checked]="isHeaderSelected(header)"
                (change)="toggleHeader(header, $any($event.target).checked)"
              />
              <span>{{ header.name }}</span>
            </label>
          }
        </div>
      </div>
      <div class="table_oc" style="overflow: scroll;">
          <table class="csv-report-table">
            <thead>
              <tr>
                @for (header of selectedHeaders; track header.key) {
                  <th>{{ header.name }}</th>
                }
              </tr>
            </thead>
            <tbody>
              <!-- rows populate once filterApplied() resolves -->
            </tbody>
          </table>
      </div>
</div>